export const getArrayParam = (params, key, fallback = []) => {
  const directValues = params.getAll(key);
  const rawValues =
    directValues.length > 0
      ? directValues
      : params.get(key)
      ? [params.get(key)]
      : [];

  const values = rawValues
    .flatMap((value) => String(value).split(","))
    .map((value) => value.trim())
    .filter(Boolean);

  return values.length > 0 ? values : fallback;
};

export const getNumberParam = (params, key, fallback) => {
  const value = params.get(key);
  if (value === null || value === "") return fallback;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const getStringParam = (params, key, fallback = "") => {
  const value = params.get(key);
  return value === null ? fallback : value;
};

export const setArrayParam = (params, key, values) => {
  params.delete(key);
  (values || [])
    .map((value) => String(value))
    .map((value) => value.trim())
    .filter(Boolean)
    .forEach((value) => params.append(key, value));
};

export const setNumberParam = (params, key, value) => {
  if (value === null || value === undefined || value === "") {
    params.delete(key);
    return;
  }
  params.set(key, String(value));
};

export const setStringParam = (params, key, value) => {
  if (value === null || value === undefined || value === "") {
    params.delete(key);
    return;
  }
  params.set(key, String(value));
};
